module.exports = __webpack_public_path__ + "static/media/faccia_08.08194769.png";